'use client';

import { Root } from '@radix-ui/react-visually-hidden';

const VisuallyHidden = Root;

export { VisuallyHidden };
